var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"venue-list-detailed"},[_c('venues-list-view',{attrs:{"isLoading":_vm.loading,"selected":_vm.shortlisted,"venues":_vm.venues,"addToListLabel":"Add To Inspections"},on:{"select":_vm.addToShortlist,"remove":_vm.removeFromShortlist}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }